import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  empty: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    margin: '92px 256px 0px 256px',
    [theme.breakpoints.down('md')]: {
      margin: '92px 5px 0px 5px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '92px 0px 0px 0px',
      justifyContent: 'space-around !important',
    },
  },
  phoneNumber: {
    color: `${theme.palette.primary.main} !important`,
  },
  emptyBody: {
    marginTop: '16px !important',
    color: 'rgba(0, 0, 0, 0.75)',
    textAlign: 'center',
    fontFamily: 'Roboto !important',
    fontSize: '13px !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    lineHeight: '143% !important',
    letterSpacing: '0.15px !important',
  },
  subTitle: {
    marginTop: '33px !important',
    marginBottom: '10px !important',
  },
  emptyTitle: {
    color: `${theme.palette.primary.main} !important`,
    textAlign: 'center',
    fontFamily: 'Roboto !important',
    fontSize: '22px !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    lineHeight: '133.4% !important',
  },
  buttonCancel: {
    width: '200px',
    height: '36px',
    borderRadius: '15px !important',
    border: `1px solid ${theme.palette.primary.main} !important`,
    fontSize: '14px !important',
    color: `${theme.palette.primary.main} !important`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px !important',
    },
  },
  buttonSubmit: {
    width: '200px',
    height: '36px',
    borderRadius: '15px !important',
    border: `1px solid ${theme.palette.primary.main} !important`,
    fontSize: '14px !important',
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `white !important`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px !important',
    },
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: theme.zIndex.drawer + 1,
  },
  link: {
    fontFamily: 'Roboto !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lineHeight: '143%',
    cursor: 'pointer',
    color: `${theme.palette.primary.main} !important`,
  },
}));
